<template>
	<div>
		<div @mousemove="move" class="w3l-banner">
			<div :style="'transform: translate(' +
			(position == 'left' ? '20' : '-20') +
			'px,' +
			(position2 == 'top' ? '10' : '-10') +
			'px) scale(1.1)'
			" class="banner-image"></div>
			<div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">


			</div>
		</div>

		<div class="twoSectionBoxStyle">
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'z'">
				<div class="wow bounceInUp twoTitleT1Style">Cookies政策</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. 介绍</p>
					<p>本Cookies政策解释了索图科技技术有限公司（“索图科技”）如何在我们的网站上使用Cookies和类似技术。使用我们的网站即表示您同意按照本政策使用Cookies。</p>
					<p class="t">2. 什么是Cookies？</p>
					<p>Cookies是您访问网站时放置在您的设备（计算机、智能手机或其他电子设备）上的小文本文件。它们被广泛用于使网站正常运行或更高效地运行，以及向网站所有者提供信息。</p>
					<p class="t">3. 我们使用的Cookies类型</p>
					<p>必要Cookies：这些Cookies是网站正常运行所必需的，不能在我们的系统中关闭。它们通常仅在响应您所做的服务请求时设置，例如设置您的隐私偏好、登录或填写表格。</p>
					<p>性能Cookies：这些Cookies允许我们计算访问量和流量来源，从而测量和提高我们网站的性能。它们帮助我们了解哪些页面最受欢迎和最不受欢迎，并查看访问者如何在网站上移动。</p>
					<p>功能性Cookies：这些Cookies使网站能够提供增强的功能和个性化。这些Cookies可能由我们或我们已添加到页面的第三方提供商设置。</p>
					<p>目标Cookies：这些Cookies可能由我们的广告合作伙伴通过我们的网站设置。它们可能被这些公司用来建立您的兴趣档案，并在其他网站上向您显示相关广告。</p>
					<p class="t">4. 管理Cookies</p>
					<p>您可以根据需要管理和/或删除Cookies。您可以设置浏览器阻止或提醒您这些Cookies，但这可能导致网站的某些部分无法正常工作。有关如何管理Cookies的更多信息，请访问
						www.aboutcookies.org。</p>
					<p class="t">5. 本Cookies政策的变更</p>
					<p>我们可能会不时更新本Cookies政策，以反映我们的实践变更或出于其他操作、法律或监管原因。请定期查看本Cookies政策，以了解我们对Cookies和相关技术的使用情况。</p>
					<p class="t">6. 联系我们</p>
					<p>如果您对我们使用Cookies或其他技术有任何疑问，请通过以下方式联系我们：</p>
					<p>电子邮件：info@suntone.com </p>
					<p>地址：索图科技技术有限公司</p>
					<p>香港特别行政区鲗鱼涌英皇道728号K11 Atelier 五楼545</p>
				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'f'">
				<div class="wow bounceInUp twoTitleT1Style">Cookies政策</div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. 介紹</p>
					<p>本Cookies政策解釋了索圖科技技術有限公司（「索圖科技」）如何在我們的網站上使用Cookies和類似技術。使用我們的網站即表示您同意按照本政策使用Cookies。</p>
					<p class="t">2. 什麽是Cookies？</p>
					<p>Cookies是您訪問網站時放置在您的設備（計算機、智能手機或其他電子設備）上的小文本文件。它們被廣泛用於使網站正常運行或更高效地運行，以及向網站所有者提供信息。</p>
					<p class="t">3. 我們使用的Cookies類型</p>
					<p>必要Cookies：這些Cookies是網站正常運行所必需的，不能在我們的系統中關閉。它們通常僅在響應您所做的服務請求時設置，例如設置您的隱私偏好、登錄或填寫表格。</p>
					<p>性能Cookies：這些Cookies允許我們計算訪問量和流量來源，從而測量和提高我們網站的性能。它們幫助我們了解哪些頁面最受歡迎和最不受歡迎，並查看訪問者如何在網站上移動。</p>
					<p>功能性Cookies：這些Cookies使網站能夠提供增強的功能和個性化。這些Cookies可能由我們或我們已添加到頁面的第三方提供商設置。</p>
					<p>目標Cookies：這些Cookies可能由我們的廣告合作夥伴通過我們的網站設置。它們可能被這些公司用來建立您的興趣檔案，並在其他網站上向您顯示相關廣告。</p>
					<p class="t">4. 管理Cookies</p>
					<p>您可以根據需要管理和/或刪除Cookies。您可以設置瀏覽器阻止或提醒您這些Cookies，但這可能導致網站的某些部分無法正常工作。有關如何管理Cookies的更多信息，請訪問
						www.aboutcookies.org。</p>
					<p class="t">5. 本Cookies政策的變更</p>
					<p>我們可能會不時更新本Cookies政策，以反映我們的實踐變更或出於其他操作、法律或監管原因。請定期查看本Cookies政策，以了解我們對Cookies和相關技術的使用情況。</p>
					<p class="t">6. 聯系我們</p>
					<p>如果您對我們使用Cookies或其他技術有任何疑問，請通過以下方式聯系我們：</p>
					<p>電子郵件：info@suntone.com </p>
					<p>地址：索圖科技技術有限公司</p>
					<p>香港特別行政區鲗魚涌英皇道728號K11 Atelier 五樓545</p>
				</div>
			</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'e'">

				<div class="wow bounceInUp twoTitleT1Style">Cookie Policy </div>
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="t">1. Introduction</p>
					<p>This Cookie Policy explains how Suntone Technology Co., Limited ("Suntone Technology") uses
						cookies and similar technologies on our website. By using our website, you consent to the use of
						cookies as described in this policy.</p>
					<p class="t">2. What are Cookies?</p>
					<p>Cookies are small text files that are placed on your device (computer, smartphone, or other
						electronic device) when you visit a website. They are widely used to make websites work, or work
						more efficiently, as well as to provide information to the website owners.</p>
					<p class="t">3. Types of Cookies We Use</p>
					<p>Essential Cookies: These cookies are necessary for the website to function and cannot be switched
						off in our systems. They are usually set only in response to actions made by you which amount to
						a request for services, such as setting your privacy preferences, logging in, or filling in
						forms.</p>
					<p>Performance Cookies: These cookies allow us to count visits and traffic sources so we can measure
						and improve the performance of our site. They help us to know which pages are the most and least
						popular and see how visitors move around the site.</p>
					<p>Functionality Cookies: These cookies enable the website to provide enhanced functionality and
						personalization. They may be set by us or by third-party providers whose services we have added
						to our pages.</p>
					<p>Targeting Cookies: These cookies may be set through our site by our advertising partners. They
						may be used by those companies to build a profile of your interests and show you relevant
						adverts on other sites.</p>
					<p class="t">4. Managing Cookies</p>
					<p>You can manage and/or delete cookies as you wish. You can set your browser to block or alert you
						about these cookies, but some parts of the site may not work as a result. For more information
						on how to manage cookies, please visit www.aboutcookies.org.</p>
					<p class="t">5. Changes to This Cookie Policy</p>
					<p>We may update this Cookie Policy from time to time to reflect changes in our practices or for
						other operational, legal, or regulatory reasons. Please revisit this Cookie Policy regularly to
						stay informed about our use of cookies and related technologies.</p>
					<p class="t">6. Contact Us</p>
					<p>If you have any questions about our use of cookies or other technologies, please contact us at:
					</p>
					<p>Email: info@suntone.com </p>
					<p>Address: </p>
					<p>Suntone Technology Co., Limited</p>
					<p>Room 545,5/F, K11 Atelier, 728 King's Road.Quarry Bay, Hong Kong</p>
				</div>
			</div>

		</div>






	</div>
</template>
<!-- <script src="https://smtpjs.com/v3/smtp.js"></script> -->
<script>


import { Email } from "../utils/smtp.js";
import { WOW } from "wowjs";

export default {
	name: "index",
	data: (vm) => {
		return {
			bodyW: 0,
			bodyY: 0,
			position: "",
			position2: "",
			contList: {
			},
			contType: "z",

		};
	},
	methods: {
		move(e) {
			if (e.pageX > this.bodyW / 2) {
				this.position = "right";
			} else {
				this.position = "left";
			}
			if (e.pageY > 250) {
				this.position2 = "top";
			} else {
				this.position2 = "bottom";
			}
		},
		changeTypeTitleName() {
			if (this.contType == "f") {
				document.title = "Cookies政策";
			} else if (this.contType == 'e') {
				document.title = 'Cookie Policy'
			} else {
				document.title = "Cookies政策";
			}
		}

	},

	mounted() {
		this.bodyW = document.body.clientWidth;
		this.bodyY = document.body.clientHeight;
		var that = this;
		this.contType = window.localStorage.getItem('language');
		that.changeTypeTitleName()
		window.addEventListener('setItemEvent', function (e) {
			if (e.key == "language") {
				that.contType = e.newValue;
				that.changeTypeTitleName()
			}
		})
		var wow = new WOW({
			boxClass: "wow",
			animateClass: "animated",
			offset: 40,
			mobile: true,
			live: true,
		});
		wow.init();
		//QOFGPGRDUUMNZALE


	},
};
</script>

<style src="../assets/css/AboutUs-pc.css" scoped></style>
<style src="../assets/css/AboutUs-phone.css" scoped></style>
<style scoped>
.titleBox {
	padding-top: 0px;
}

.w3l-banner {
	height: 130px;
}

.twoTitleT2Style {
	display: block;
	max-width: 1120px;
}

p {
	text-indent: 0%;
}

.twoTitleT2Style ul li {
	text-indent: none;
}

.t {
	margin-top: 10px;
	font-weight: 700;
}

@media screen and (min-width: 801px) {
	p {
		text-indent: 0%;
	}

	.twoTitleT2Style ul li {
		text-indent: none;
	}
}
</style>
<!-- </style> -->
